import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import Badge from "../../components/common/Badge";
import Stars from "../../components/common/Stars";
import FImg from "../../components/common/FImg";
import Fld from "../../components/common/Fld";
import ImgUploadFld from "../../components/common/ImgUploadFld";
import Dlg from "../../components/common/Dlg";
import { ABt, filt } from "../AdminUI";

export default function TestimonialsTab() {
  const { db, saveDB, delDB } = useData();
  const { toast, srch } = useOutletContext();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fs = k => v => setForm(f => ({ ...f, [k]: v }));
  const close = () => { setModal(false); setForm({}); };
  const save = r => { saveDB("testimonials", r); toast(r.id ? "Updated" : "Added"); close(); };
  const del = id => { delDB("testimonials", id); toast("Deleted"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <ABt variant="orange" onClick={() => { setForm({ name: "", role: "", company: "", rating: 5, text: "", image: "", status: "published" }); setModal(true); }}>+ Add Testimonial</ABt>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 13 }}>
        {filt(db.testimonials || [], ["name", "company", "text"], srch).map(t => (
          <div key={t.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 17px", boxShadow: "0 2px 5px rgba(0,0,0,.04)" }}>
            <div style={{ display: "flex", gap: 11, alignItems: "flex-start", marginBottom: 10 }}>
              <FImg src={t.image} h={44} placeholder="person" style={{ width: 44, height: 44, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
              <div style={{ flex: 1 }}><div style={{ fontWeight: 700, color: C.dark, fontSize: 13.5 }}>{t.name}</div><div style={{ fontSize: 12, color: C.orange, fontWeight: 600, marginTop: 1 }}>{t.role}, {t.company}</div><Stars n={t.rating} /></div>
              <Badge v={t.status} />
            </div>
            <p style={{ fontSize: 12.5, color: C.gray, lineHeight: 1.6, marginBottom: 11, fontStyle: "italic" }}>"{t.text}"</p>
            <div style={{ display: "flex", gap: 6 }}>
              <ABt variant={t.status === "published" ? "amber" : "green"} onClick={() => save({ ...t, status: t.status === "published" ? "draft" : "published" })}>{t.status === "published" ? "Hide" : "Show"}</ABt>
              <ABt onClick={() => { setForm({ ...t }); setModal(true); }}>Edit</ABt>
              <ABt variant="red" onClick={() => del(t.id)}>Del</ABt>
            </div>
          </div>
        ))}
        {!(db.testimonials || []).length && <div style={{ textAlign: "center", padding: 34, color: "#94a3b8", background: "#fff", borderRadius: 11, gridColumn: "1/-1" }}>No testimonials yet.</div>}
      </div>

      {modal && <Dlg title={form.id ? "Edit Testimonial" : "Add Testimonial"} onClose={close}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="Client Name" value={form.name || ""} onChange={fs("name")} /><Fld label="Role" value={form.role || ""} onChange={fs("role")} /></div>
        <Fld label="Company" value={form.company || ""} onChange={fs("company")} />
        <Fld label="Rating" value={String(form.rating || 5)} onChange={v => fs("rating")(Number(v))} opts={["5", "4", "3", "2", "1"]} />
        <Fld label="Testimonial Text" value={form.text || ""} onChange={fs("text")} rows={4} />
        <ImgUploadFld label="Photo" value={form.image || ""} onChange={fs("image")} round w={60} h={60} maxDim={500} />
        <Fld label="Status" value={form.status || "published"} onChange={fs("status")} opts={["published", "draft"]} />
        <ABt variant="orange" onClick={() => save(form)}>{form.id ? "Update" : "Add"} Testimonial</ABt>
      </Dlg>}
    </>
  );
}
